import React, { useContext } from 'react';
import {
  RegisterAction,
  RegisterError,
  RegisterState,
} from './registerReducer';

export type RegisterContext = {
  state: RegisterState;
  dispatch: React.Dispatch<RegisterAction>;
};

export const RegisterContext = React.createContext<RegisterContext | null>(
  null,
);

export const useRegisterContext: () => [
  RegisterState,
  React.Dispatch<RegisterAction>,
] = () => {
  const context = useContext(RegisterContext);
  if (!context) {
    throw new Error('Context not found' + RegisterContext);
  }
  return [context.state, context.dispatch];
};

export const useRegister: () => RegisterState = () => {
  const [state] = useRegisterContext();
  return state;
};

export const useRegisterError = (): RegisterError | null => {
  const RegisterState = useRegister();
  const stateData = RegisterState.data;
  if (stateData.type !== 'HEALTH_AUTH' && stateData.type !== 'REGISTERED') {
    const errorCode = stateData.error;
    if (errorCode) {
      return errorCode;
    }
  }
  return null;
};
